$mol_hotkey $mol_plugin
	event *
		^
		keydown?event <=> keydown?event null
	key *
	mod_ctrl false
	mod_alt false
	mod_shift false
